import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import OrganizationApiService from './OrganizationApiService';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { GET_MARKET_DROP_DOWN_LIST } from 'Store/Organization/Market/MarketType';
import { setMarketDropDown } from 'Store/Organization/Market/MarketAction';

function* getMarketsList(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Dropdown Data...."));
        let payloadData: IPayload = {
            apiType: apiType.Organization,
            endpoint: `organizations/structure/dropdown/market/${req.regionCode}`,
            apiMethod: apiMethod.GET,
            payload: null

        }
        const response = yield call(
            OrganizationApiService.post, API_URL.PostWebApp, payloadData
        );
        yield put(setMarketDropDown(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setMarketDropDown([]));
        yield put(globalLoaderText(""));
    }
}

function* watchGetMarketDropDowns() {
    yield takeEvery(GET_MARKET_DROP_DOWN_LIST, getMarketsList)
}

export default function* combinedSaga() {
    yield all([
        watchGetMarketDropDowns()
    ])
}
